// src/constants/AnnouncementAudience.ts
var ANNOUNCEMENT_AUDIENCES = {
  ALL_USERS: "all_users",
  SELECTED_USERS: "selected_users"
};

// src/constants/accessGuard.ts
var ACCESS_GUARD = {
  UNREGISTERED_COURSE_ACCESS: "unregisteredCourseAccess",
  UNREGISTERED_QA_ACCESS: "unregisteredQAAccess",
  UNREGISTERED_NEWS_ACCESS: "unregisteredNewsAccess",
  UNREGISTERED_ARTICLES_ACCESS: "unregisteredArticlesAccess"
};

// src/constants/activityLogs.ts
var ACTIVITY_LOG_ACTION_TYPES = {
  CREATE: "create",
  DUPLICATE: "duplicate",
  UPDATE: "update",
  BULK_COURSE_CATEGORY_UPDATE: "bulk_course_category_update",
  BULK_COURSE_STATUS_UPDATE: "bulk_course_status_update",
  DELETE: "delete",
  LOGIN: "login",
  LOGIN_FAILED: "login_failed",
  LOGOUT: "logout",
  ENROLL_COURSE: "enroll_course",
  UNENROLL_COURSE: "unenroll_course",
  START_COURSE: "start_course",
  GROUP_ASSIGNMENT: "group_assignment",
  USERS_IMPORT: "users_import",
  SEND_PASSWORD_RESET_EMAIL: "send_password_reset_email",
  RESEND_PASSWORD_CREATION_EMAIL: "resend_password_creation_email",
  RESEND_MAGIC_LINK_INVITE_EMAIL: "resend_magic_link_invite_email",
  COMPLETE_LESSON: "complete_lesson",
  COMPLETE_COURSE: "complete_course",
  COMPLETE_CHAPTER: "complete_chapter",
  EXPIRE_CERTIFICATE: "expire_certificate",
  RESET_CERTIFICATE: "reset_certificate",
  VIEW_ANNOUNCEMENT: "view_announcement",
  GRADE_ANSWER: "grade_answer",
  OVERRIDE_ANSWER: "override_answer",
  OVERRIDE_RESULT: "override_result"
};
var ACTIVITY_LOG_RESOURCE_TYPES = {
  USER: "user",
  COURSE: "course",
  CHAPTER: "chapter",
  LESSON: "lesson",
  ANNOUNCEMENT: "announcement",
  GROUP: "group",
  SETTINGS: "settings",
  INTEGRATION: "integration",
  CATEGORY: "category",
  QA: "qa",
  NEWS: "news",
  ARTICLE: "article",
  ARTICLE_SECTION: "articleSection",
  LIVE_TRAINING: "live_training",
  STUDENT_ANSWER: "studentAnswer",
  STUDENT_LESSON_RESULT: "studentLessonResult"
};
var ACTIVITY_LOG_RESOURCE_ACTION_TYPES = {
  [ACTIVITY_LOG_RESOURCE_TYPES.USER]: [
    ACTIVITY_LOG_ACTION_TYPES.CREATE,
    ACTIVITY_LOG_ACTION_TYPES.UPDATE,
    ACTIVITY_LOG_ACTION_TYPES.DELETE,
    ACTIVITY_LOG_ACTION_TYPES.LOGIN,
    ACTIVITY_LOG_ACTION_TYPES.LOGIN_FAILED,
    ACTIVITY_LOG_ACTION_TYPES.LOGOUT,
    ACTIVITY_LOG_ACTION_TYPES.USERS_IMPORT,
    ACTIVITY_LOG_ACTION_TYPES.SEND_PASSWORD_RESET_EMAIL,
    ACTIVITY_LOG_ACTION_TYPES.RESEND_PASSWORD_CREATION_EMAIL,
    ACTIVITY_LOG_ACTION_TYPES.RESEND_MAGIC_LINK_INVITE_EMAIL
  ],
  [ACTIVITY_LOG_RESOURCE_TYPES.COURSE]: [
    ACTIVITY_LOG_ACTION_TYPES.CREATE,
    ACTIVITY_LOG_ACTION_TYPES.DUPLICATE,
    ACTIVITY_LOG_ACTION_TYPES.UPDATE,
    ACTIVITY_LOG_ACTION_TYPES.DELETE,
    ACTIVITY_LOG_ACTION_TYPES.BULK_COURSE_CATEGORY_UPDATE,
    ACTIVITY_LOG_ACTION_TYPES.BULK_COURSE_STATUS_UPDATE,
    ACTIVITY_LOG_ACTION_TYPES.START_COURSE,
    ACTIVITY_LOG_ACTION_TYPES.COMPLETE_COURSE,
    ACTIVITY_LOG_ACTION_TYPES.ENROLL_COURSE,
    ACTIVITY_LOG_ACTION_TYPES.EXPIRE_CERTIFICATE,
    ACTIVITY_LOG_ACTION_TYPES.RESET_CERTIFICATE
  ],
  [ACTIVITY_LOG_RESOURCE_TYPES.CHAPTER]: [
    ACTIVITY_LOG_ACTION_TYPES.CREATE,
    ACTIVITY_LOG_ACTION_TYPES.UPDATE,
    ACTIVITY_LOG_ACTION_TYPES.DELETE,
    ACTIVITY_LOG_ACTION_TYPES.COMPLETE_CHAPTER
  ],
  [ACTIVITY_LOG_RESOURCE_TYPES.LESSON]: [
    ACTIVITY_LOG_ACTION_TYPES.CREATE,
    ACTIVITY_LOG_ACTION_TYPES.UPDATE,
    ACTIVITY_LOG_ACTION_TYPES.DELETE,
    ACTIVITY_LOG_ACTION_TYPES.COMPLETE_LESSON
  ],
  [ACTIVITY_LOG_RESOURCE_TYPES.ANNOUNCEMENT]: [
    ACTIVITY_LOG_ACTION_TYPES.CREATE,
    ACTIVITY_LOG_ACTION_TYPES.VIEW_ANNOUNCEMENT
  ],
  [ACTIVITY_LOG_RESOURCE_TYPES.GROUP]: [
    ACTIVITY_LOG_ACTION_TYPES.CREATE,
    ACTIVITY_LOG_ACTION_TYPES.UPDATE,
    ACTIVITY_LOG_ACTION_TYPES.DELETE,
    ACTIVITY_LOG_ACTION_TYPES.GROUP_ASSIGNMENT,
    ACTIVITY_LOG_ACTION_TYPES.ENROLL_COURSE
  ],
  [ACTIVITY_LOG_RESOURCE_TYPES.SETTINGS]: [ACTIVITY_LOG_ACTION_TYPES.UPDATE],
  [ACTIVITY_LOG_RESOURCE_TYPES.INTEGRATION]: [ACTIVITY_LOG_ACTION_TYPES.UPDATE],
  [ACTIVITY_LOG_RESOURCE_TYPES.CATEGORY]: [
    ACTIVITY_LOG_ACTION_TYPES.CREATE,
    ACTIVITY_LOG_ACTION_TYPES.UPDATE,
    ACTIVITY_LOG_ACTION_TYPES.DELETE
  ],
  [ACTIVITY_LOG_RESOURCE_TYPES.QA]: [
    ACTIVITY_LOG_ACTION_TYPES.CREATE,
    ACTIVITY_LOG_ACTION_TYPES.UPDATE,
    ACTIVITY_LOG_ACTION_TYPES.DELETE
  ],
  [ACTIVITY_LOG_RESOURCE_TYPES.NEWS]: [
    ACTIVITY_LOG_ACTION_TYPES.CREATE,
    ACTIVITY_LOG_ACTION_TYPES.UPDATE,
    ACTIVITY_LOG_ACTION_TYPES.DELETE
  ],
  [ACTIVITY_LOG_RESOURCE_TYPES.ARTICLE]: [
    ACTIVITY_LOG_ACTION_TYPES.CREATE,
    ACTIVITY_LOG_ACTION_TYPES.UPDATE,
    ACTIVITY_LOG_ACTION_TYPES.DELETE
  ],
  [ACTIVITY_LOG_RESOURCE_TYPES.ARTICLE_SECTION]: [
    ACTIVITY_LOG_ACTION_TYPES.CREATE,
    ACTIVITY_LOG_ACTION_TYPES.UPDATE,
    ACTIVITY_LOG_ACTION_TYPES.DELETE
  ],
  [ACTIVITY_LOG_RESOURCE_TYPES.LIVE_TRAINING]: [
    ACTIVITY_LOG_ACTION_TYPES.CREATE,
    ACTIVITY_LOG_ACTION_TYPES.UPDATE,
    ACTIVITY_LOG_ACTION_TYPES.DELETE
  ],
  [ACTIVITY_LOG_RESOURCE_TYPES.STUDENT_ANSWER]: [
    ACTIVITY_LOG_ACTION_TYPES.GRADE_ANSWER,
    ACTIVITY_LOG_ACTION_TYPES.OVERRIDE_ANSWER
  ],
  [ACTIVITY_LOG_RESOURCE_TYPES.STUDENT_LESSON_RESULT]: [ACTIVITY_LOG_ACTION_TYPES.OVERRIDE_RESULT]
};

// src/constants/fileTypes.ts
var ALLOWED_LESSON_IMAGE_FILE_TYPES = [
  "image/jpeg",
  "image/png",
  "image/webp",
  "image/svg+xml"
];
var ALLOWED_IMAGE_FILE_EXTENSIONS = [".jpg", ".jpeg", ".png", ".webp", ".svg"];
var ALLOWED_VIDEO_FILE_TYPES = [
  "video/mp4",
  "video/quicktime",
  "video/webm",
  "video/ogg",
  "video/mov"
];
var ALLOWED_VIDEO_FILE_EXTENSIONS = [".mp4", ".mov", ".qt", ".webm", ".ogg"];
var ALLOWED_PRESENTATION_FILE_TYPES = [
  "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  "application/vnd.oasis.opendocument.presentation"
];
var ALLOWED_PRESENTATION_FILE_EXTENSIONS = [".pptx", ".odp"];
var ALLOWED_ODP_FILE_TYPES = ["application/vnd.oasis.opendocument.presentation"];
var ALLOWED_EXCEL_FILE_TYPES = [
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "text/csv"
];
var ALLOWED_SPREADSHEET_FILE_EXTENSIONS = [".xlsx", ".csv"];
var ALLOWED_WORD_FILE_TYPES = [
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
];
var ALLOWED_WORD_FILE_EXTENSIONS = [".docx"];
var ALLOWED_PDF_FILE_TYPES = ["application/pdf"];
var ALLOWED_PDF_FILE_EXTENSIONS = [".pdf"];
var ALLOWED_AUDIO_FILE_TYPES = [
  "audio/mpeg",
  "audio/mp3",
  "audio/wav",
  "audio/ogg",
  "audio/aac",
  "audio/x-m4a"
];
var ALLOWED_AUDIO_FILE_EXTENSIONS = [".mp3", ".wav", ".ogg", ".aac", ".m4a"];
var ALLOWED_MARKDOWN_FILE_TYPES = [
  "text/markdown",
  "text/x-markdown",
  "application/x-markdown"
];

// src/constants/aiMentorAvatar.ts
var ALLOWED_EXTENSIONS = ALLOWED_IMAGE_FILE_EXTENSIONS.join(",");

// src/constants/aiMentorTypes.ts
var AI_MENTOR_TYPE = {
  MENTOR: "mentor",
  TEACHER: "teacher",
  ROLEPLAY: "roleplay"
};

// src/constants/aiMentorVoice.ts
var AI_MENTOR_VOICE_MODE = {
  PRESET: "preset",
  CUSTOM: "custom"
};
var AI_MENTOR_TTS_PRESET = {
  MALE: "male",
  FEMALE: "female"
};

// src/constants/allowedAge.ts
var ALLOWED_AGE_LIMITS = [13, 16, null];

// src/constants/announcements.ts
var ANNOUNCEMENT_STATUSES = {
  SCHEDULED: "scheduled",
  PUBLISHED: "published"
};
var ANNOUNCEMENT_FEEDS = {
  ALL: "all",
  ADMIN_ANNOUNCEMENTS: "admin_announcements",
  SYSTEM: "system"
};
var ANNOUNCEMENT_SOURCE_TYPES = {
  MANUAL: "manual",
  LIVE_TRAINING: "live_training",
  COURSE_DUE_DATE_REMINDER: "course_due_date_reminder",
  COURSE_CHAT: "course_chat"
};
var ANNOUNCEMENT_EMAIL_TEMPLATES = {
  DEFAULT: "default",
  LIVE_TRAINING_REMINDER: "live_training_reminder",
  LIVE_TRAINING_STARTED: "live_training_started",
  LIVE_TRAINING_ENDED: "live_training_ended"
};

// src/constants/answerReview.ts
var ANSWER_REVIEW_STATUS = {
  NOT_REQUIRED: "not_required",
  AWAITING_REVIEW: "awaiting_review",
  REVIEWED: "reviewed"
};
var QUESTION_GRADING_MODE = {
  PASS_FAIL: "pass_fail",
  SCALE_0_5: "scale_0_5"
};
var QUESTION_GRADING_MODE_MAX_SCORE = {
  [QUESTION_GRADING_MODE.PASS_FAIL]: 1,
  [QUESTION_GRADING_MODE.SCALE_0_5]: 5
};

// src/constants/articlesSettings.ts
var ALLOWED_ARTICLES_SETTINGS = {
  ARTICLES_ENABLED: "articlesEnabled",
  UNREGISTERED_USER_ARTICLES_ACCESSIBILITY: "unregisteredUserArticlesAccessibility"
};

// src/constants/articlesTypes.ts
var ARTICLE_STATUS = {
  PUBLISHED: "published",
  DRAFT: "draft"
};

// src/constants/auth.ts
var AUTH_TOKEN_PURPOSE = {
  ACCESS: "access",
  REFRESH: "refresh",
  MFA: "mfa"
};
var AUTH_SESSION_STATUS = {
  AUTHENTICATED: "authenticated",
  MFA_REQUIRED: "mfa_required"
};

// src/constants/calendar.ts
var CALENDAR_EVENT_SOURCE_TYPES = {
  LIVE_TRAINING: "live_training",
  COURSE_DUE_DATE: "course_due_date"
};
var CALENDAR_EVENT_SOURCE_ROLES = {
  ADMIN: "admin",
  AUTHOR: "author",
  TRAINER: "trainer",
  OBSERVER: "observer"
};

// src/constants/certificate.ts
var SHARE_IMAGE_WIDTH = 1200;
var SHARE_IMAGE_HEIGHT = Math.round(SHARE_IMAGE_WIDTH * 210 / 297);
var CERTIFICATE_STATUSES = {
  ACTIVE: "issued",
  ARCHIVED: "revoked",
  PENDING: "pending",
  ISSUED: "issued",
  REVOKED: "revoked"
};
var CERTIFICATE_ARCHIVE_REASONS = {
  EXPIRED: "expired",
  MANUAL_RESET: "manual_reset"
};
var CERTIFICATE_VALIDITY_TYPES = {
  PERIOD: "period",
  FIXED_DATE: "fixedDate"
};
var CERTIFICATE_VALIDITY_UNITS = {
  DAYS: "days",
  MONTHS: "months",
  YEARS: "years"
};
var CERTIFICATE_RESET_SCOPES = {
  ALL: "all",
  GROUPS: "groups",
  USERS: "users"
};
var CERTIFICATE_MODES = {
  DISABLED: "disabled",
  MANUAL: "manual",
  AUTOMATIC: "automatic"
};
var CERTIFICATE_RESULTS = {
  COMPLETED: "Completed",
  PENDING: "Pending",
  REVOKED: "Revoked"
};
var CERTIFICATE_TARGET_TYPES = {
  COURSE: "course",
  LEARNING_PATH: "learning_path"
};

// src/constants/course.ts
var COURSE_STATUSES = {
  DRAFT: "draft",
  PUBLISHED: "published",
  PRIVATE: "private"
};
var COURSE_PROGRESS_STATUSES = {
  NOT_STARTED: "not_started",
  IN_PROGRESS: "in_progress",
  COMPLETED: "completed",
  BLOCKED: "blocked"
};
var COURSE_TYPE = {
  DEFAULT: "default",
  SCORM: "scorm"
};
var COURSE_FEATURE = {
  CURRICULUM_EDITING: "curriculum_editing",
  LESSON_SEQUENCE_SETTING: "lesson_sequence_setting",
  QUIZ_FEEDBACK_SETTING: "quiz_feedback_setting"
};
var COURSE_FEATURE_ERROR_TRANSLATION_KEY = {
  [COURSE_FEATURE.CURRICULUM_EDITING]: "adminCourseView.errors.featureUnavailable.curriculum",
  [COURSE_FEATURE.LESSON_SEQUENCE_SETTING]: "adminCourseView.errors.featureUnavailable.lessonSequence",
  [COURSE_FEATURE.QUIZ_FEEDBACK_SETTING]: "adminCourseView.errors.featureUnavailable.quizFeedback"
};
var COURSE_TYPE_DISABLED_FEATURES = {
  [COURSE_TYPE.DEFAULT]: [],
  [COURSE_TYPE.SCORM]: [
    COURSE_FEATURE.CURRICULUM_EDITING,
    COURSE_FEATURE.LESSON_SEQUENCE_SETTING,
    COURSE_FEATURE.QUIZ_FEEDBACK_SETTING
  ]
};
var isCourseFeatureEnabledForCourseType = (courseType, feature) => {
  const disabledFeatures = COURSE_TYPE_DISABLED_FEATURES[courseType];
  return !disabledFeatures.includes(feature);
};
var MAX_COURSE_TITLE_LENGTH = 255;

// src/constants/courseChat.ts
var COURSE_CHAT_SOCKET_EVENTS = {
  JOIN: "join:course-chat",
  LEAVE: "leave:course-chat",
  MESSAGE_CREATED: "course-chat:message-created",
  USER_PRESENCE_CHANGED: "course-chat:user-presence-changed",
  USER_MENTIONED: "course-chat:user-mentioned",
  MESSAGE_REACTIONS_UPDATED: "course-chat:message-reactions-updated",
  MESSAGE_DELETED: "course-chat:message-deleted"
};
var COURSE_CHAT_ALLOWED_REACTIONS = ["\u{1F44D}", "\u2764\uFE0F", "\u{1F602}", "\u{1F389}", "\u{1F62E}"];
var getCourseChatRoom = (courseId) => `course-chat:${courseId}`;

// src/constants/courseEnrollment.ts
var COURSE_ENROLLMENT = {
  ENROLLED: "enrolled",
  NOT_ENROLLED: "not_enrolled",
  GROUP_ENROLLED: "group_enrolled"
};

// src/constants/difficultyLevels.ts
var DIFFICULTY_LEVEL = {
  BEGINNER: "BEGINNER",
  INTERMEDIATE: "INTERMEDIATE",
  ADVANCED: "ADVANCED",
  EXPERT: "EXPERT"
};
var DIFFICULTY_LEVEL_ORDER = [
  DIFFICULTY_LEVEL.BEGINNER,
  DIFFICULTY_LEVEL.INTERMEDIATE,
  DIFFICULTY_LEVEL.ADVANCED,
  DIFFICULTY_LEVEL.EXPERT
];

// src/constants/entityTypes.ts
var ENTITY_TYPES = {
  COURSE: "course",
  CHAPTER: "chapter",
  LESSON: "lesson",
  QUESTION: "question",
  NEWS: "news",
  ARTICLES: "articles",
  LEARNING_PATH: "learning_path",
  QA: "qa",
  USER: "user",
  CATEGORY: "category",
  ANNOUNCEMENT: "announcement",
  GLOBAL_SETTINGS: "global_settings",
  LIVE_TRAINING: "live_training"
};

// src/constants/externalIntegrations.ts
var EXTERNAL_INTEGRATIONS_ENABLED = {
  posthog: false,
  sentry: false,
  stripe: false
};

// src/constants/features.ts
var FEATURES = {
  QA: "qa",
  NEWS: "news",
  ARTICLES: "articles",
  MODERN_COURSE_LIST: "modern_course_list",
  CALENDAR: "calendar",
  LIVE_TRAINING: "live_training",
  COURSE_DISCUSSIONS: "course_discussions"
};
var FEATURE_SETTINGS_KEYS = {
  [FEATURES.QA]: "QAEnabled",
  [FEATURES.NEWS]: "newsEnabled",
  [FEATURES.ARTICLES]: "articlesEnabled",
  [FEATURES.MODERN_COURSE_LIST]: "modernCourseListEnabled",
  [FEATURES.CALENDAR]: "calendarEnabled",
  [FEATURES.LIVE_TRAINING]: "liveTrainingEnabled",
  [FEATURES.COURSE_DISCUSSIONS]: "courseDiscussionsEnabled"
};

// src/constants/fileUpload.ts
var BYTES_PER_MEGABYTE = 1024 * 1024;
var MEGABYTE_UNIT = "MB";
var MAX_FILE_SIZE_MB = 100;
var MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * BYTES_PER_MEGABYTE;
var MAX_VIDEO_FILE_SIZE_MB = 5 * 1024;
var MAX_VIDEO_FILE_SIZE_BYTES = MAX_VIDEO_FILE_SIZE_MB * BYTES_PER_MEGABYTE;
var MAX_COURSE_TRAILER_VIDEO_SIZE_MB = 200;
var MAX_COURSE_TRAILER_VIDEO_SIZE_BYTES = MAX_COURSE_TRAILER_VIDEO_SIZE_MB * BYTES_PER_MEGABYTE;
var MAX_PRESENTATION_FILE_SIZE_MB = 100;
var MAX_PRESENTATION_FILE_SIZE_BYTES = MAX_PRESENTATION_FILE_SIZE_MB * BYTES_PER_MEGABYTE;
var MAX_IMAGE_FILE_SIZE_MB = 20;
var MAX_IMAGE_FILE_SIZE_BYTES = MAX_IMAGE_FILE_SIZE_MB * BYTES_PER_MEGABYTE;
var MAX_SETTINGS_IMAGE_FILE_SIZE_MB = 10;
var MAX_SETTINGS_IMAGE_FILE_SIZE_BYTES = MAX_SETTINGS_IMAGE_FILE_SIZE_MB * BYTES_PER_MEGABYTE;
var MAX_AVATAR_FILE_SIZE_MB = 5;
var MAX_AVATAR_FILE_SIZE_BYTES = MAX_AVATAR_FILE_SIZE_MB * BYTES_PER_MEGABYTE;
var MAX_INGESTION_FILE_COUNT = 3;
var MAX_INGESTION_FILE_SIZE_MB = 10;
var MAX_INGESTION_FILE_SIZE_BYTES = MAX_INGESTION_FILE_SIZE_MB * BYTES_PER_MEGABYTE;
var MAX_SCORM_PACKAGE_SIZE_MB = 512;
var MAX_SCORM_PACKAGE_SIZE_BYTES = MAX_SCORM_PACKAGE_SIZE_MB * BYTES_PER_MEGABYTE;
var MAX_SCORM_THUMBNAIL_FILE_SIZE_MB = 20;
var MAX_SCORM_THUMBNAIL_FILE_SIZE_BYTES = MAX_SCORM_THUMBNAIL_FILE_SIZE_MB * BYTES_PER_MEGABYTE;

// src/constants/languages.ts
var SUPPORTED_LANGUAGES = {
  EN: "en",
  PL: "pl",
  DE: "de",
  LT: "lt",
  CS: "cs",
  ES: "es",
  FR: "fr"
};
var SUPPORTED_LANGUAGE_VALUES = new Set(Object.values(SUPPORTED_LANGUAGES));
var isSupportedLanguage = (language) => SUPPORTED_LANGUAGE_VALUES.has(language);

// src/constants/learningPath.ts
var LEARNING_PATH_STATUSES = {
  DRAFT: "draft",
  PUBLISHED: "published",
  PRIVATE: "private"
};
var LEARNING_PATH_ENROLLMENT_TYPES = {
  DIRECT: "direct",
  GROUP: "group"
};
var LEARNING_PATH_PROGRESS_STATUSES = {
  NOT_STARTED: "not_started",
  IN_PROGRESS: "in_progress",
  COMPLETED: "completed"
};
var LEARNING_PATH_ENTITY_TYPES = {
  LEARNING_PATH: "learning_path",
  COURSE: "course"
};
var LEARNING_PATH_CERTIFICATE_STATUSES = {
  ACTIVE: "active",
  EXPIRED: "expired"
};

// src/constants/lessonTypes.ts
var LESSON_TYPES = {
  CONTENT: "content",
  QUIZ: "quiz",
  AI_MENTOR: "ai_mentor",
  EMBED: "embed",
  SCORM: "scorm",
  LIVE_TRAINING: "live_training"
};

// src/constants/liveTraining.ts
var CALENDAR_EVENT_STATUSES = {
  SCHEDULED: "scheduled",
  CANCELLED: "cancelled",
  ENDED: "ended",
  EXPIRED: "expired"
};
var LIVE_TRAINING_DELIVERY_TYPES = {
  ONLINE: "online",
  OFFLINE: "offline"
};
var LIVE_TRAINING_VISIBILITY_SCOPES = {
  ALL: "all",
  LINKED_COURSES: "linked_courses"
};
var LIVE_TRAINING_STATUSES = {
  SCHEDULED: "scheduled",
  ACTIVE: "active",
  ENDED: "ended",
  CANCELLED: "cancelled",
  EXPIRED: "expired"
};
var LIVE_TRAINING_SESSION_STATUSES = {
  WAITING: "waiting",
  ACTIVE: "active",
  ENDED: "ended",
  FAILED: "failed"
};
var LIVE_TRAINING_MEMBER_ROLES = {
  HOST: "host",
  CO_TRAINER: "co_trainer",
  MODERATOR: "moderator",
  OBSERVER: "observer"
};
var LIVE_TRAINING_PARTICIPANT_ROLES = {
  ...LIVE_TRAINING_MEMBER_ROLES,
  ADMIN: "admin"
};
var LIVE_TRAINING_LINK_ENTITY_TYPES = {
  COURSE: "course"
};
var LIVE_TRAINING_RESOURCE_RELATIONSHIP_TYPES = {
  BEFORE: "live_training_before",
  AFTER: "live_training_after"
};
var DEFAULT_LIVE_TRAINING_SETTINGS = {
  viewerPermissions: {
    microphoneEnabled: false,
    cameraEnabled: false
  }
};
var LIVE_TRAINING_MAX_PARTICIPANTS_LIMIT = 100;
var LIVE_TRAINING_TITLE_MAX_LENGTH = 120;
var LIVE_TRAINING_DESCRIPTION_MAX_LENGTH = 500;
var LIVE_TRAINING_SOCKET_ROOMS = {
  LIVE_TRAINING: "live-training",
  LIVE_TRAINING_SESSION: "live-training-session",
  LIVE_TRAINING_USER: "live-training-user"
};
var LIVE_TRAINING_SOCKET_CLIENT_EVENTS = {
  SUBSCRIBE: "liveTraining:subscribe",
  UNSUBSCRIBE: "liveTraining:unsubscribe",
  SESSION_START: "liveTraining:session:start",
  SESSION_END: "liveTraining:session:end",
  PARTICIPANT_HEARTBEAT: "liveTraining:participant:heartbeat",
  PARTICIPANT_LEAVE: "liveTraining:participant:leave"
};
var LIVE_TRAINING_SOCKET_SERVER_EVENTS = {
  SESSION_STARTED: "liveTraining:session:started",
  SESSION_ENDED: "liveTraining:session:ended",
  SESSION_STATUS_CHANGED: "liveTraining:session:statusChanged",
  PARTICIPANT_JOINED: "liveTraining:participant:joined",
  PARTICIPANT_LEFT: "liveTraining:participant:left",
  PARTICIPANT_UPDATED: "liveTraining:participant:updated",
  ATTENDANCE_UPDATED: "liveTraining:attendance:updated",
  POPUP_AVAILABLE: "liveTraining:popup:available",
  ERROR: "liveTraining:error"
};
var LIVE_TRAINING_SOCKET_ROOM_BUILDERS = {
  liveTraining: (liveTrainingId) => `${LIVE_TRAINING_SOCKET_ROOMS.LIVE_TRAINING}:${liveTrainingId}`,
  liveTrainingSession: (sessionId) => `${LIVE_TRAINING_SOCKET_ROOMS.LIVE_TRAINING_SESSION}:${sessionId}`,
  liveTrainingUser: (userId) => `${LIVE_TRAINING_SOCKET_ROOMS.LIVE_TRAINING_USER}:${userId}`
};

// src/constants/loginPageDocuments.ts
var MAX_LOGIN_PAGE_DOCUMENTS = 3;

// src/constants/lumaCourseGeneration.ts
var COURSE_GENERATION_SYNC_SOCKET_EVENT = "luma-course-generation:sync-status-changed";
var COURSE_GENERATION_SYNC_STATUS = {
  NOT_STARTED: "not_started",
  PROCESSING: "processing",
  FAILED: "failed",
  PROCESSED: "processed",
  DISMISSED: "dismissed"
};
var COURSE_GENERATION_MESSAGE_KEY = {
  PLANNING_NEXT_STEP: "PLANNING_NEXT_STEP",
  USING_TOOLS: "USING_TOOLS",
  SUMMARIZING_CONTEXT: "SUMMARIZING_CONTEXT",
  ANALYZING_OBJECTIVES: "ANALYZING_OBJECTIVES",
  SCANNING_LEARNING_EVIDENCE: "SCANNING_LEARNING_EVIDENCE",
  RUNNING_CURRICULUM_DESIGN: "RUNNING_CURRICULUM_DESIGN",
  INITIALIZING_CURRICULUM_PLAN: "INITIALIZING_CURRICULUM_PLAN",
  DESIGNING_CHAPTERS: "DESIGNING_CHAPTERS",
  DESIGNING_LESSON_BLUEPRINTS: "DESIGNING_LESSON_BLUEPRINTS",
  FINALIZING_COURSE_STRUCTURE: "FINALIZING_COURSE_STRUCTURE",
  PREPARING_FINAL_COURSE_SHELL: "PREPARING_FINAL_COURSE_SHELL",
  FINALIZING_LESSON_PAYLOADS: "FINALIZING_LESSON_PAYLOADS",
  COURSE_FINISHED: "COURSE_FINISHED",
  WRITING_RESPONSE: "WRITING_RESPONSE",
  WAITING_FOR_CONFIRMATION: "WAITING_FOR_CONFIRMATION",
  THINKING: "THINKING"
};
var COURSE_GENERATION_STREAM_EVENT_TYPE = {
  COURSE_GENERATED: "course.generated",
  DESIGNER_CHAPTER_GENERATED: "designer.chapter.generated",
  ARCHITECT_LESSON_GENERATED: "architect.lesson.generated",
  ASSET_REQUESTED: "asset.requested"
};

// src/constants/lumaFileIngestion.ts
var LUMA_FILE_INGESTION_ALLOWED_MIME_TYPES = [
  "application/pdf",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "text/plain",
  "text/markdown",
  "text/x-markdown",
  "application/x-markdown"
];
var LUMA_FILE_INGESTION_ALLOWED_EXTENSIONS = [
  ".pdf",
  ".docx",
  ".txt",
  ".md",
  ".xmd"
];

// src/constants/masterCourse.ts
var COURSE_ORIGIN_TYPES = {
  REGULAR: "regular",
  MASTER: "master",
  EXPORTED: "exported"
};
var MASTER_COURSE_EXPORT_SYNC_STATUSES = {
  ACTIVE: "active",
  FAILED: "failed",
  PAUSED: "paused"
};
var MASTER_COURSE_ENTITY_TYPES = {
  COURSE: "course",
  CHAPTER: "chapter",
  LESSON: "lesson",
  QUESTION: "question",
  OPTION: "option",
  RESOURCE: "resource",
  RESOURCE_ENTITY: "resource_entity",
  AI_MENTOR_LESSON: "ai_mentor_lesson"
};

// src/constants/newsSettings.ts
var ALLOWED_NEWS_SETTINGS = {
  NEWS_ENABLED: "newsEnabled",
  UNREGISTERED_USER_NEWS_ACCESSIBILITY: "unregisteredUserNewsAccessibility"
};
var NEWS_STATUS = {
  DRAFT: "draft",
  PUBLISHED: "published"
};

// src/constants/notificationType.ts
var USER_NOTIFICATION_TYPE = {
  PASSWORD_SETUP: "password_setup",
  // default
  MAGIC_LINK_INVITE: "magic_link_invite",
  AD_SSO: "ad_sso",
  NONE: "none"
};

// src/constants/permissions.ts
var SYSTEM_ROLE_SLUGS = {
  ADMIN: "admin",
  STUDENT: "student",
  CONTENT_CREATOR: "content_creator",
  TRAINER: "trainer",
  OBSERVER: "observer"
};
var PERMISSIONS = {
  ACCOUNT_READ_SELF: "account.read_self",
  ACCOUNT_UPDATE_SELF: "account.update_self",
  USER_READ_SELF: "user.read_self",
  USER_MANAGE: "user.manage",
  SETTINGS_READ_SELF: "settings.read_self",
  SETTINGS_UPDATE_SELF: "settings.update_self",
  SETTINGS_MANAGE: "settings.manage",
  ENV_READ_PUBLIC: "env.read_public",
  ENV_MANAGE: "env.manage",
  CATEGORY_READ: "category.read",
  CATEGORY_MANAGE: "category.manage",
  GROUP_READ: "group.read",
  GROUP_MANAGE: "group.manage",
  LEARNING_PATH_READ: "learning_path.read",
  LEARNING_PATH_CREATE: "learning_path.create",
  LEARNING_PATH_UPDATE: "learning_path.update",
  LEARNING_PATH_UPDATE_OWN: "learning_path.update_own",
  LEARNING_PATH_DELETE: "learning_path.delete",
  LEARNING_PATH_COURSE_UPDATE: "learning_path.course_update",
  LEARNING_PATH_COURSE_UPDATE_OWN: "learning_path.course_update_own",
  LEARNING_PATH_ENROLLMENT: "learning_path.enrollment",
  LEARNING_PATH_EXPORT: "learning_path.export",
  CALENDAR_READ: "calendar.read",
  LIVE_TRAINING_READ: "live_training.read",
  LIVE_TRAINING_CREATE: "live_training.create",
  LIVE_TRAINING_UPDATE: "live_training.update",
  LIVE_TRAINING_UPDATE_OWN: "live_training.update_own",
  LIVE_TRAINING_DELETE: "live_training.delete",
  LIVE_TRAINING_DELETE_OWN: "live_training.delete_own",
  LIVE_TRAINING_JOIN: "live_training.join",
  LIVE_TRAINING_START: "live_training.start",
  LIVE_TRAINING_END: "live_training.end",
  LIVE_TRAINING_STATISTICS: "live_training.statistics",
  COURSE_READ_ASSIGNED: "course.read_assigned",
  COURSE_READ_MANAGEABLE: "course.read_manageable",
  COURSE_READ: "course.read",
  COURSE_CREATE: "course.create",
  COURSE_UPDATE: "course.update",
  COURSE_UPDATE_OWN: "course.update_own",
  COURSE_DELETE: "course.delete",
  COURSE_ENROLLMENT: "course.enrollment",
  COURSE_STATISTICS: "course.statistics",
  COURSE_EXPORT: "course.export",
  COURSE_DISCUSSION_READ: "course_discussion.read",
  COURSE_DISCUSSION_MESSAGE_CREATE: "course_discussion.message.create",
  COURSE_DISCUSSION_MESSAGE_REACT: "course_discussion.message.react",
  COURSE_DISCUSSION_MESSAGE_DELETE_OWN: "course_discussion.message.delete_own",
  COURSE_DISCUSSION_MESSAGE_DELETE: "course_discussion.message.delete",
  LEARNING_MODE_USE: "learning_mode.use",
  LEARNING_PROGRESS_UPDATE: "learning_progress.update",
  CERTIFICATE_READ: "certificate.read",
  CERTIFICATE_SHARE: "certificate.share",
  CERTIFICATE_RENDER: "certificate.render",
  CERTIFICATE_MANAGE: "certificate.manage",
  FILE_UPLOAD: "file.upload",
  FILE_DELETE: "file.delete",
  AI_USE: "ai.use",
  ANNOUNCEMENT_READ: "announcement.read",
  ANNOUNCEMENT_CREATE: "announcement.create",
  ANNOUNCEMENT_DELETE: "announcement.delete",
  NEWS_READ_PUBLIC: "news.read_public",
  NEWS_MANAGE: "news.manage",
  NEWS_MANAGE_OWN: "news.manage_own",
  ARTICLE_READ_PUBLIC: "article.read_public",
  ARTICLE_MANAGE: "article.manage",
  ARTICLE_MANAGE_OWN: "article.manage_own",
  QA_READ_PUBLIC: "qa.read_public",
  QA_MANAGE: "qa.manage",
  QA_MANAGE_OWN: "qa.manage_own",
  REPORT_READ: "report.read",
  STATISTICS_READ_SELF: "statistics.read_self",
  STATISTICS_READ: "statistics.read",
  BILLING_CHECKOUT: "billing.checkout",
  BILLING_MANAGE: "billing.manage",
  INTEGRATION_KEY_MANAGE: "integration_key.manage",
  INTEGRATION_API_USE: "integration_api.use",
  TENANT_MANAGE: "tenant.manage",
  COURSE_AI_GENERATION: "course.ai_generation",
  ANSWER_REVIEW: "answer.review",
  ANSWER_GRADE: "answer.grade",
  ANSWER_OVERRIDE: "answer.override",
  ACTIVITY_LOG_READ: "activity_log.read"
};
var SYSTEM_ROLE_PERMISSIONS = {
  [SYSTEM_ROLE_SLUGS.STUDENT]: [
    PERMISSIONS.ACCOUNT_READ_SELF,
    PERMISSIONS.ACCOUNT_UPDATE_SELF,
    PERMISSIONS.USER_READ_SELF,
    PERMISSIONS.SETTINGS_READ_SELF,
    PERMISSIONS.SETTINGS_UPDATE_SELF,
    PERMISSIONS.ENV_READ_PUBLIC,
    PERMISSIONS.CATEGORY_READ,
    PERMISSIONS.COURSE_READ_ASSIGNED,
    PERMISSIONS.COURSE_READ,
    PERMISSIONS.COURSE_DISCUSSION_READ,
    PERMISSIONS.COURSE_DISCUSSION_MESSAGE_CREATE,
    PERMISSIONS.COURSE_DISCUSSION_MESSAGE_REACT,
    PERMISSIONS.COURSE_DISCUSSION_MESSAGE_DELETE_OWN,
    PERMISSIONS.LEARNING_PATH_READ,
    PERMISSIONS.CALENDAR_READ,
    PERMISSIONS.LIVE_TRAINING_READ,
    PERMISSIONS.LIVE_TRAINING_JOIN,
    PERMISSIONS.LEARNING_PROGRESS_UPDATE,
    PERMISSIONS.CERTIFICATE_READ,
    PERMISSIONS.CERTIFICATE_SHARE,
    PERMISSIONS.CERTIFICATE_RENDER,
    PERMISSIONS.FILE_UPLOAD,
    PERMISSIONS.AI_USE,
    PERMISSIONS.ANNOUNCEMENT_READ,
    PERMISSIONS.STATISTICS_READ_SELF,
    PERMISSIONS.BILLING_CHECKOUT,
    PERMISSIONS.NEWS_READ_PUBLIC,
    PERMISSIONS.ARTICLE_READ_PUBLIC,
    PERMISSIONS.QA_READ_PUBLIC
  ],
  [SYSTEM_ROLE_SLUGS.CONTENT_CREATOR]: [
    PERMISSIONS.ACCOUNT_READ_SELF,
    PERMISSIONS.ACCOUNT_UPDATE_SELF,
    PERMISSIONS.USER_READ_SELF,
    PERMISSIONS.SETTINGS_READ_SELF,
    PERMISSIONS.SETTINGS_UPDATE_SELF,
    PERMISSIONS.ENV_READ_PUBLIC,
    PERMISSIONS.CATEGORY_READ,
    PERMISSIONS.GROUP_READ,
    PERMISSIONS.COURSE_READ_ASSIGNED,
    PERMISSIONS.COURSE_READ_MANAGEABLE,
    PERMISSIONS.COURSE_READ,
    PERMISSIONS.COURSE_DISCUSSION_READ,
    PERMISSIONS.COURSE_DISCUSSION_MESSAGE_CREATE,
    PERMISSIONS.COURSE_DISCUSSION_MESSAGE_REACT,
    PERMISSIONS.COURSE_DISCUSSION_MESSAGE_DELETE_OWN,
    PERMISSIONS.LEARNING_PATH_READ,
    PERMISSIONS.LEARNING_PATH_CREATE,
    PERMISSIONS.LEARNING_PATH_UPDATE_OWN,
    PERMISSIONS.LEARNING_PATH_COURSE_UPDATE_OWN,
    PERMISSIONS.CALENDAR_READ,
    PERMISSIONS.LIVE_TRAINING_READ,
    PERMISSIONS.LIVE_TRAINING_JOIN,
    PERMISSIONS.LEARNING_PROGRESS_UPDATE,
    PERMISSIONS.LEARNING_MODE_USE,
    PERMISSIONS.COURSE_CREATE,
    PERMISSIONS.COURSE_UPDATE_OWN,
    PERMISSIONS.COURSE_STATISTICS,
    PERMISSIONS.CERTIFICATE_READ,
    PERMISSIONS.CERTIFICATE_SHARE,
    PERMISSIONS.CERTIFICATE_RENDER,
    PERMISSIONS.CERTIFICATE_MANAGE,
    PERMISSIONS.FILE_UPLOAD,
    PERMISSIONS.FILE_DELETE,
    PERMISSIONS.AI_USE,
    PERMISSIONS.COURSE_AI_GENERATION,
    PERMISSIONS.ANNOUNCEMENT_READ,
    PERMISSIONS.ANNOUNCEMENT_CREATE,
    PERMISSIONS.NEWS_MANAGE_OWN,
    PERMISSIONS.NEWS_READ_PUBLIC,
    PERMISSIONS.ARTICLE_MANAGE_OWN,
    PERMISSIONS.ARTICLE_READ_PUBLIC,
    PERMISSIONS.QA_MANAGE_OWN,
    PERMISSIONS.QA_READ_PUBLIC,
    PERMISSIONS.REPORT_READ,
    PERMISSIONS.STATISTICS_READ_SELF,
    PERMISSIONS.STATISTICS_READ,
    PERMISSIONS.BILLING_CHECKOUT,
    PERMISSIONS.ANSWER_REVIEW,
    PERMISSIONS.ANSWER_GRADE
  ],
  [SYSTEM_ROLE_SLUGS.TRAINER]: [
    PERMISSIONS.ACCOUNT_READ_SELF,
    PERMISSIONS.ACCOUNT_UPDATE_SELF,
    PERMISSIONS.USER_READ_SELF,
    PERMISSIONS.SETTINGS_READ_SELF,
    PERMISSIONS.SETTINGS_UPDATE_SELF,
    PERMISSIONS.ENV_READ_PUBLIC,
    PERMISSIONS.CATEGORY_READ,
    PERMISSIONS.CALENDAR_READ,
    PERMISSIONS.GROUP_READ,
    PERMISSIONS.COURSE_READ_ASSIGNED,
    PERMISSIONS.COURSE_READ_MANAGEABLE,
    PERMISSIONS.COURSE_READ,
    PERMISSIONS.COURSE_ENROLLMENT,
    PERMISSIONS.COURSE_STATISTICS,
    PERMISSIONS.LEARNING_PATH_READ,
    PERMISSIONS.LEARNING_PATH_ENROLLMENT,
    PERMISSIONS.LEARNING_PROGRESS_UPDATE,
    PERMISSIONS.LEARNING_MODE_USE,
    PERMISSIONS.LIVE_TRAINING_READ,
    PERMISSIONS.LIVE_TRAINING_CREATE,
    PERMISSIONS.LIVE_TRAINING_UPDATE_OWN,
    PERMISSIONS.LIVE_TRAINING_DELETE_OWN,
    PERMISSIONS.LIVE_TRAINING_JOIN,
    PERMISSIONS.LIVE_TRAINING_START,
    PERMISSIONS.LIVE_TRAINING_END,
    PERMISSIONS.LIVE_TRAINING_STATISTICS,
    PERMISSIONS.CERTIFICATE_READ,
    PERMISSIONS.CERTIFICATE_SHARE,
    PERMISSIONS.CERTIFICATE_RENDER,
    PERMISSIONS.CERTIFICATE_MANAGE,
    PERMISSIONS.FILE_UPLOAD,
    PERMISSIONS.AI_USE,
    PERMISSIONS.ANNOUNCEMENT_READ,
    PERMISSIONS.NEWS_READ_PUBLIC,
    PERMISSIONS.ARTICLE_READ_PUBLIC,
    PERMISSIONS.QA_READ_PUBLIC,
    PERMISSIONS.REPORT_READ,
    PERMISSIONS.STATISTICS_READ_SELF,
    PERMISSIONS.STATISTICS_READ,
    PERMISSIONS.ANSWER_REVIEW,
    PERMISSIONS.ANSWER_GRADE,
    PERMISSIONS.ANSWER_OVERRIDE
  ],
  [SYSTEM_ROLE_SLUGS.OBSERVER]: [
    PERMISSIONS.ACCOUNT_READ_SELF,
    PERMISSIONS.ACCOUNT_UPDATE_SELF,
    PERMISSIONS.ANNOUNCEMENT_READ,
    PERMISSIONS.CALENDAR_READ,
    PERMISSIONS.ENV_READ_PUBLIC,
    PERMISSIONS.LIVE_TRAINING_JOIN,
    PERMISSIONS.LIVE_TRAINING_READ,
    PERMISSIONS.SETTINGS_READ_SELF,
    PERMISSIONS.SETTINGS_UPDATE_SELF,
    PERMISSIONS.USER_READ_SELF
  ],
  [SYSTEM_ROLE_SLUGS.ADMIN]: [
    PERMISSIONS.ACCOUNT_READ_SELF,
    PERMISSIONS.ACCOUNT_UPDATE_SELF,
    PERMISSIONS.USER_READ_SELF,
    PERMISSIONS.SETTINGS_READ_SELF,
    PERMISSIONS.SETTINGS_UPDATE_SELF,
    PERMISSIONS.SETTINGS_MANAGE,
    PERMISSIONS.ENV_READ_PUBLIC,
    PERMISSIONS.ENV_MANAGE,
    PERMISSIONS.CATEGORY_READ,
    PERMISSIONS.CATEGORY_MANAGE,
    PERMISSIONS.GROUP_READ,
    PERMISSIONS.GROUP_MANAGE,
    PERMISSIONS.LEARNING_PATH_READ,
    PERMISSIONS.LEARNING_PATH_CREATE,
    PERMISSIONS.LEARNING_PATH_UPDATE,
    PERMISSIONS.LEARNING_PATH_DELETE,
    PERMISSIONS.LEARNING_PATH_COURSE_UPDATE,
    PERMISSIONS.LEARNING_PATH_ENROLLMENT,
    PERMISSIONS.LEARNING_PATH_EXPORT,
    PERMISSIONS.CALENDAR_READ,
    PERMISSIONS.LIVE_TRAINING_READ,
    PERMISSIONS.LIVE_TRAINING_CREATE,
    PERMISSIONS.LIVE_TRAINING_UPDATE,
    PERMISSIONS.LIVE_TRAINING_UPDATE_OWN,
    PERMISSIONS.LIVE_TRAINING_DELETE,
    PERMISSIONS.LIVE_TRAINING_DELETE_OWN,
    PERMISSIONS.LIVE_TRAINING_JOIN,
    PERMISSIONS.LIVE_TRAINING_START,
    PERMISSIONS.LIVE_TRAINING_END,
    PERMISSIONS.LIVE_TRAINING_STATISTICS,
    PERMISSIONS.COURSE_READ_ASSIGNED,
    PERMISSIONS.COURSE_READ_MANAGEABLE,
    PERMISSIONS.COURSE_READ,
    PERMISSIONS.COURSE_DISCUSSION_READ,
    PERMISSIONS.COURSE_DISCUSSION_MESSAGE_CREATE,
    PERMISSIONS.COURSE_DISCUSSION_MESSAGE_REACT,
    PERMISSIONS.COURSE_DISCUSSION_MESSAGE_DELETE_OWN,
    PERMISSIONS.COURSE_DISCUSSION_MESSAGE_DELETE,
    PERMISSIONS.LEARNING_MODE_USE,
    PERMISSIONS.COURSE_CREATE,
    PERMISSIONS.COURSE_UPDATE,
    PERMISSIONS.COURSE_DELETE,
    PERMISSIONS.COURSE_STATISTICS,
    PERMISSIONS.COURSE_ENROLLMENT,
    PERMISSIONS.CERTIFICATE_READ,
    PERMISSIONS.CERTIFICATE_SHARE,
    PERMISSIONS.CERTIFICATE_RENDER,
    PERMISSIONS.CERTIFICATE_MANAGE,
    PERMISSIONS.FILE_UPLOAD,
    PERMISSIONS.FILE_DELETE,
    PERMISSIONS.AI_USE,
    PERMISSIONS.COURSE_AI_GENERATION,
    PERMISSIONS.ANNOUNCEMENT_READ,
    PERMISSIONS.ANNOUNCEMENT_CREATE,
    PERMISSIONS.ANNOUNCEMENT_DELETE,
    PERMISSIONS.NEWS_MANAGE,
    PERMISSIONS.NEWS_READ_PUBLIC,
    PERMISSIONS.ARTICLE_MANAGE,
    PERMISSIONS.ARTICLE_READ_PUBLIC,
    PERMISSIONS.QA_MANAGE,
    PERMISSIONS.QA_READ_PUBLIC,
    PERMISSIONS.REPORT_READ,
    PERMISSIONS.STATISTICS_READ_SELF,
    PERMISSIONS.STATISTICS_READ,
    PERMISSIONS.BILLING_CHECKOUT,
    PERMISSIONS.BILLING_MANAGE,
    PERMISSIONS.USER_MANAGE,
    PERMISSIONS.INTEGRATION_KEY_MANAGE,
    PERMISSIONS.INTEGRATION_API_USE,
    PERMISSIONS.TENANT_MANAGE,
    PERMISSIONS.COURSE_EXPORT,
    PERMISSIONS.ANSWER_REVIEW,
    PERMISSIONS.ANSWER_GRADE,
    PERMISSIONS.ANSWER_OVERRIDE,
    PERMISSIONS.ACTIVITY_LOG_READ
  ]
};
var SYSTEM_RULE_SET_SLUGS = {
  [SYSTEM_ROLE_SLUGS.STUDENT]: "student-default",
  [SYSTEM_ROLE_SLUGS.CONTENT_CREATOR]: "content_creator-default",
  [SYSTEM_ROLE_SLUGS.TRAINER]: "trainer-default",
  [SYSTEM_ROLE_SLUGS.OBSERVER]: "observer-default",
  [SYSTEM_ROLE_SLUGS.ADMIN]: "admin-default"
};

// src/constants/qaSettings.ts
var ALLOWED_QA_SETTINGS = {
  QA_ENABLED: "QAEnabled",
  UNREGISTERED_USER_QA_ACCESSIBILITY: "unregisteredUserQAAccessibility"
};

// src/constants/registrationForm.ts
var FORM_TYPES = {
  REGISTRATION: "registration"
};
var FORM_FIELD_TYPES = /* @__PURE__ */ ((FORM_FIELD_TYPES2) => {
  FORM_FIELD_TYPES2["CHECKBOX"] = "checkbox";
  return FORM_FIELD_TYPES2;
})(FORM_FIELD_TYPES || {});
var MAX_USER_NAME_LENGTH = 64;

// src/constants/resourceLibrary.ts
var RESOURCE_LIBRARY_ASSET_TYPE = {
  IMAGE: "image",
  VIDEO: "video",
  PDF: "pdf",
  PRESENTATION: "presentation",
  DOCUMENT: "document",
  OTHER: "other"
};

// src/constants/scorm-runtime.ts
var SCORM_12_API_METHODS = {
  INITIALIZE: "LMSInitialize",
  SET_VALUE: "LMSSetValue",
  COMMIT: "LMSCommit",
  FINISH: "LMSFinish",
  GET_VALUE: "LMSGetValue",
  GET_LAST_ERROR: "LMSGetLastError",
  GET_ERROR_STRING: "LMSGetErrorString",
  GET_DIAGNOSTIC: "LMSGetDiagnostic"
};
var SCORM_12_RUNTIME_SETTINGS = {
  autocommit: false,
  dataCommitFormat: "flattened",
  logLevel: "ERROR",
  sendFullCommit: false
};

// src/constants/scorm-bridge.ts
var SCORM_BRIDGE_METHODS = {
  INITIALIZE: SCORM_12_API_METHODS.INITIALIZE,
  SET_VALUE: SCORM_12_API_METHODS.SET_VALUE,
  COMMIT: SCORM_12_API_METHODS.COMMIT,
  FINISH: SCORM_12_API_METHODS.FINISH
};
var SCORM_BRIDGE_MESSAGE_TYPES = {
  READY: "mentingo:scorm:ready",
  INITIALIZE: "mentingo:scorm:initialize",
  CALL: "mentingo:scorm:call"
};
var SCORM_BRIDGE_CONFIG = {
  READY_RETRY_INTERVAL_MS: 500,
  READY_TIMEOUT_MS: 3e4,
  MAX_KEY_LENGTH: 255,
  MAX_VALUE_LENGTH: 4096,
  SESSION_PATTERN: "^[a-f0-9-]{36}$"
};

// src/constants/scorm-content.ts
var SCORM_CONTENT_PATHS = {
  CONTROLLER: "scorm/delivery/:token",
  PREFIX: "/api/scorm/delivery/",
  PLAYER: "player",
  ASSETS: "assets",
  RUNTIME_SCRIPT: "runtime.js",
  BOOTSTRAP_SCRIPT: "bootstrap.js"
};
var SCORM_CONTENT_TOKEN = {
  BYTE_LENGTH: 32,
  LENGTH: 64,
  PATTERN: "^[a-f0-9]{64}$"
};
var SCORM_CONTENT_ACCESS = {
  GRANT_TTL_SECONDS: 15 * 60,
  RENEW_INTERVAL_MS: 5 * 60 * 1e3
};
var SCORM_PLAYER_ATTRIBUTES = {
  SANDBOX: "allow-scripts allow-same-origin allow-forms allow-modals",
  REFERRER_POLICY: "no-referrer",
  IFRAME_ALLOW: "camera 'none'; microphone 'none'; geolocation 'none'; payment 'none'",
  CONTENT_FRAME_TEST_ID: "scorm-package-iframe"
};

// src/constants/scorm.ts
var SCORM_STANDARD = {
  SCORM_1_2: "scorm_1_2",
  SCORM_2004: "scorm_2004"
};
var SCORM_PACKAGE_ENTITY_TYPE = {
  COURSE: "course",
  LESSON: "lesson"
};
var SCORM_PACKAGE_STATUS = {
  PROCESSING: "processing",
  READY: "ready",
  FAILED: "failed"
};
var SCORM_IMPORT_ACTION = {
  CREATE_COURSE: "create-course",
  CREATE_LESSON: "create-lesson",
  ATTACH_LESSON_PACKAGE: "attach-lesson-package"
};
var SCORM_IMPORT_SOCKET = {
  EVENTS: {
    STATUS_CHANGED: "scorm-import-status-change"
  },
  MESSAGE_KEYS: {
    PROCESSING: "adminScorm.importProcessing.description",
    READY: "adminScorm.importSuccess.description",
    FAILED_COURSE: "adminScorm.importFailure.courseDescription",
    FAILED_LESSON: "adminScorm.importFailure.lessonDescription"
  }
};
var SCORM_COMPLETION_STATUS = {
  COMPLETED: "completed",
  INCOMPLETE: "incomplete",
  NOT_ATTEMPTED: "not_attempted",
  UNKNOWN: "unknown"
};
var SCORM_SUCCESS_STATUS = {
  PASSED: "passed",
  FAILED: "failed",
  UNKNOWN: "unknown"
};
var ALLOWED_SCORM_PACKAGE_MIME_TYPES = [
  "application/zip",
  "application/x-zip-compressed"
];
var ALLOWED_SCORM_PACKAGE_FILE_EXTENSIONS = [".zip"];

// src/constants/sessionRevocation.ts
var SESSION_REVOCATION_SOCKET = {
  EVENTS: {
    PERMISSIONS_UPDATED: "permissions-updated"
  },
  REASONS: {
    ROLES_CHANGED: "roles_changed"
  },
  MESSAGE_KEYS: {
    PERMISSIONS_UPDATED: "sessionRevocation.permissionsUpdated"
  }
};

// src/constants/supportMode.ts
var SUPPORT_SESSION_STATUSES = {
  PENDING: "pending",
  ACTIVE: "active",
  REVOKED: "revoked"
};

// src/constants/tenant.ts
var TENANT_STATUSES = {
  ACTIVE: "active",
  INACTIVE: "inactive"
};

// src/constants/theme.ts
var HEX_COLOR_REGEX = /^#(?:[0-9a-fA-F]{3}){1,2}$/;

// src/constants/tus.ts
var DEFAULT_TUS_CHUNK_SIZE = 50 * 1024 * 1024;
var DEFAULT_TUS_TTL_MS = 4 * 60 * 60 * 1e3;

// src/constants/videoAutoplayActions.ts
var VIDEO_AUTOPLAY = {
  AUTOPLAY: "autoplay",
  AUTOPLAY_WITH_PLAY_NEXT: "autoplay_with_play_next",
  PLAY_NEXT: "play_next",
  NO_AUTOPLAY: "no_autoplay"
};

// src/constants/videoProviders.ts
var VIDEO_EMBED_PROVIDERS = {
  SELF: "self",
  YOUTUBE: "youtube",
  VIMEO: "vimeo",
  BUNNY: "bunny",
  UNKNOWN: "unknown"
};

// src/constants/voiceAction.ts
var VOICE_ACTION = {
  TRANSCRIPT: "transcript",
  VOICE_MENTOR: "voiceMentor"
};
var VOICE_SOCKET_EVENT = {
  START_AUDIO: "startAudio",
  AUDIO_STARTED: "audioStarted",
  AUDIO_CHUNK: "audioChunk",
  AUDIO_SPEECH: "audioSpeech",
  AUDIO_INTERRUPTED: "audioInterrupted",
  AUDIO_OUTPUT_COMPLETED: "audioOutputCompleted",
  MENTOR_TRANSCRIPTION: "mentorTranscription",
  MENTOR_RESPONSE_COMPLETED: "mentorResponseCompleted",
  STOP_AUDIO: "stopAudio",
  CANCEL_AUDIO: "cancelAudio",
  TRIGGER_TTS: "triggerTTS"
};

// src/constants/voiceModeState.ts
var VOICE_MODE_STATE = {
  IDLE: "idle",
  LISTENING: "listening",
  THINKING: "thinking",
  SPEAKING: "speaking"
};

// src/types/onboarding.ts
var OnboardingPages = /* @__PURE__ */ ((OnboardingPages2) => {
  OnboardingPages2["DASHBOARD"] = "dashboard";
  OnboardingPages2["COURSES"] = "courses";
  OnboardingPages2["ANNOUNCEMENTS"] = "announcements";
  OnboardingPages2["PROFILE"] = "profile";
  OnboardingPages2["SETTINGS"] = "settings";
  OnboardingPages2["PROVIDER_INFORMATION"] = "providerInformation";
  return OnboardingPages2;
})(OnboardingPages || {});

// src/types/videoUploadTypes.ts
var VIDEO_UPLOAD_STATUS = {
  QUEUED: "queued",
  UPLOADED: "uploaded",
  PROCESSED: "processed",
  FAILED: "failed"
};
var VIDEO_PROVIDERS = {
  BUNNY: "bunny",
  S3: "s3"
};

// src/utils/blankAnswerMarkers.ts
var BLANK_ANSWER_MARKER_REGEX = /<blank-answer-([^>]+)>/g;

// src/utils/certificate.ts
var defaultCertificateRenderTheme = {
  titleColor: "#1f2937",
  certifyTextColor: "#374151",
  nameColor: "#1f2937",
  courseNameColor: "#1f2937",
  bodyTextColor: "#4b5563",
  labelTextColor: "#1f2937",
  lineColor: "#9ca3af",
  logoColor: "#1f2937"
};
var CERTIFICATE_KIND = {
  COURSE: "course",
  LEARNING_PATH: "learningPath"
};
var certificateTranslations = {
  pl: {
    certificate: "CERTYFIKAT",
    courseCompletion: "UKO\u0143CZENIA KURSU",
    certifyThat: "NINIEJSZYM ZA\u015AWIADCZA SI\u0118, \u017BE",
    successfulCompletion: {
      [CERTIFICATE_KIND.COURSE]: "uko\u0144czy\u0142/a kurs",
      [CERTIFICATE_KIND.LEARNING_PATH]: "uko\u0144czy\u0142/a \u015Bcie\u017Ck\u0119 rozwoju"
    },
    confirmation: "potwierdzaj\u0105c tym samym realizacj\u0119 programu szkoleniowego.",
    date: "Data",
    score: "Wynik",
    result: "Rezultat",
    completed: "Zaliczono",
    certificateId: "Identyfikator",
    expiryDate: "Wygasa",
    signature: "Podpis"
  },
  en: {
    certificate: "CERTIFICATE",
    courseCompletion: "OF COURSE COMPLETION",
    certifyThat: "THIS IS TO CERTIFY THAT",
    successfulCompletion: {
      [CERTIFICATE_KIND.COURSE]: "has successfully completed the course",
      [CERTIFICATE_KIND.LEARNING_PATH]: "has successfully completed the development path"
    },
    confirmation: "thereby confirming participation in the full training program.",
    date: "Date",
    score: "Score",
    result: "Result",
    completed: "Completed",
    certificateId: "Identifier",
    expiryDate: "Expires",
    signature: "Signature"
  },
  de: {
    certificate: "ZERTIFIKAT",
    courseCompletion: "KURSABSCHLUSS",
    certifyThat: "HIERMIT WIRD BEST\xC4TIGT, DASS",
    successfulCompletion: {
      [CERTIFICATE_KIND.COURSE]: "hat den Kurs erfolgreich abgeschlossen",
      [CERTIFICATE_KIND.LEARNING_PATH]: "hat den Entwicklungspfad erfolgreich abgeschlossen"
    },
    confirmation: "und best\xE4tigt damit die Teilnahme am gesamten Schulungsprogramm.",
    date: "Datum",
    score: "Ergebnis",
    result: "Ergebnis",
    completed: "Bestanden",
    certificateId: "Kennung",
    expiryDate: "L\xE4uft ab",
    signature: "Unterschrift"
  },
  lt: {
    certificate: "SERTIFIKATAS",
    courseCompletion: "KURSO PABAIGOS",
    certifyThat: "\u0160IUO PATVIRTINAMA, KAD",
    successfulCompletion: {
      [CERTIFICATE_KIND.COURSE]: "s\u0117kmingai baig\u0117 kurs\u0105",
      [CERTIFICATE_KIND.LEARNING_PATH]: "s\u0117kmingai baig\u0117 tobul\u0117jimo keli\u0105"
    },
    confirmation: "taip patvirtindamas dalyvavim\u0105 visoje mokymo programoje.",
    date: "Data",
    score: "Rezultatas",
    result: "Rezultatas",
    completed: "I\u0161laikyta",
    certificateId: "Identifikatorius",
    expiryDate: "Galioja iki",
    signature: "Para\u0161as"
  },
  cs: {
    certificate: "CERTIFIK\xC1T",
    courseCompletion: "UKON\u010CEN\xCD KURZU",
    certifyThat: "T\xCDMTO SE POTVRZUJE, \u017DE",
    successfulCompletion: {
      [CERTIFICATE_KIND.COURSE]: "\xFAsp\u011B\u0161n\u011B absolvoval/a kurz",
      [CERTIFICATE_KIND.LEARNING_PATH]: "\xFAsp\u011B\u0161n\u011B dokon\u010Dil/a rozvojovou cestu"
    },
    confirmation: "\u010D\xEDm\u017E potvrzuje \xFA\u010Dast na cel\xE9m \u0161kolic\xEDm programu.",
    date: "Datum",
    score: "V\xFDsledek",
    result: "V\xFDsledek",
    completed: "Spln\u011Bno",
    certificateId: "Identifik\xE1tor",
    expiryDate: "Plat\xED do",
    signature: "Podpis"
  },
  es: {
    certificate: "CERTIFICADO",
    courseCompletion: "DE FINALIZACI\xD3N DEL CURSO",
    certifyThat: "SE CERTIFICA QUE",
    successfulCompletion: {
      [CERTIFICATE_KIND.COURSE]: "ha completado correctamente el curso",
      [CERTIFICATE_KIND.LEARNING_PATH]: "ha completado correctamente la ruta de desarrollo"
    },
    confirmation: "confirmando as\xED su participaci\xF3n en todo el programa formativo.",
    date: "Fecha",
    score: "Puntuaci\xF3n",
    result: "Resultado",
    completed: "Completado",
    certificateId: "Identificador",
    expiryDate: "Caduca",
    signature: "Firma"
  },
  fr: {
    certificate: "CERTIFICAT",
    courseCompletion: "DE R\xC9USSITE DU COURS",
    certifyThat: "CECI CERTIFIE QUE",
    successfulCompletion: {
      [CERTIFICATE_KIND.COURSE]: "a termin\xE9 avec succ\xE8s le cours",
      [CERTIFICATE_KIND.LEARNING_PATH]: "a termin\xE9 avec succ\xE8s le parcours de d\xE9veloppement"
    },
    confirmation: "confirmant ainsi sa participation \xE0 l'ensemble du programme de formation.",
    date: "Date",
    score: "Score",
    result: "R\xE9sultat",
    completed: "Termin\xE9",
    certificateId: "Identifiant",
    expiryDate: "Expire le",
    signature: "Signature"
  }
};
function buildCertificateMarkup(options) {
  const {
    studentName = "",
    courseName = "",
    completionDate = "",
    certificateId = null,
    score = null,
    result = null,
    expiryDate = "",
    platformLogoUrl,
    signatureImageUrl,
    backgroundImageUrl,
    lang = "en",
    colorTheme = defaultCertificateRenderTheme,
    isDownload = false,
    certificateKind = CERTIFICATE_KIND.COURSE
  } = options;
  const t = certificateTranslations[lang];
  const resolveColor = (key) => normalizeCertificateColor(colorTheme[key], defaultCertificateRenderTheme[key]);
  const safeTheme = {
    titleColor: resolveColor("titleColor"),
    certifyTextColor: resolveColor("certifyTextColor"),
    nameColor: resolveColor("nameColor"),
    courseNameColor: resolveColor("courseNameColor"),
    bodyTextColor: resolveColor("bodyTextColor"),
    labelTextColor: resolveColor("labelTextColor"),
    lineColor: resolveColor("lineColor"),
    logoColor: resolveColor("logoColor")
  };
  const backgroundStyle = [
    backgroundImageUrl ? `background-image:url("${escapeCssUrl(backgroundImageUrl)}");background-size:100% 100%;background-position:center;background-repeat:no-repeat;` : "background-color:white;"
  ].join("");
  const logoMarkup = platformLogoUrl ? `<img src="${escapeHtml(platformLogoUrl)}" alt="Platform Logo" class="aspect-auto h-11" />` : `<div class="h-11" style="color:${escapeHtml(safeTheme.logoColor)};">${APP_LOGO_SVG}</div>`;
  const signatureImageMarkup = signatureImageUrl ? `<img src="${escapeHtml(signatureImageUrl)}" alt="${escapeHtml(t.signature)}" class="mb-2 h-16 w-full object-contain" />` : "";
  const footerGapClass = expiryDate ? "gap-x-16" : "gap-x-52";
  const expiryDateMarkup = expiryDate ? `<div class="flex w-[280px] flex-col items-center">
        <p
          class="text-[18px] text-gray-600"
          style="color:${escapeHtml(safeTheme.bodyTextColor)};"
        >
          ${escapeHtml(expiryDate)}
        </p>
        <hr
          class="mx-auto mb-3 w-full"
          style="border-color:${escapeHtml(safeTheme.lineColor)};"
        />
        <p
          class="text-[18px] uppercase text-gray-800"
          style="color:${escapeHtml(safeTheme.labelTextColor)};"
        >
          ${escapeHtml(t.expiryDate)}
        </p>
      </div>` : "";
  const certificateBodyMarkup = `<div
    class="flex h-full w-full flex-col items-center justify-center gap-y-12 px-14 py-12"
    style="${escapeHtml(backgroundStyle)}"
  >
    ${logoMarkup}
    <div class="flex flex-col items-center justify-center gap-y-4">
      <p
        class="text-[62px] font-black uppercase tracking-wider"
        style="color:${escapeHtml(safeTheme.titleColor)};"
      >
        ${escapeHtml(t.certificate)}
      </p>
      <p
        class="text-[17px] font-semibold uppercase tracking-[0.2em]"
        style="color:${escapeHtml(safeTheme.certifyTextColor)};"
      >
        ${escapeHtml(t.certifyThat)}
      </p>
    </div>

    <div class="flex flex-col items-center justify-center">
      <p
        class="mb-4 text-[44px] tracking-wider"
        style="color:${escapeHtml(safeTheme.nameColor)};"
      >
        ${escapeHtml(studentName)}
      </p>
      <p
        class="text-[18px] text-gray-600"
        style="color:${escapeHtml(safeTheme.bodyTextColor)};"
      >
        ${escapeHtml(t.successfulCompletion[certificateKind])}
      </p>
      <p
        class="text-[24px]"
        style="color:${escapeHtml(safeTheme.courseNameColor)};"
      >
        "${escapeHtml(courseName)}"
      </p>
      <p
        class="text-[18px] text-gray-600"
        style="color:${escapeHtml(safeTheme.bodyTextColor)};"
      >
        ${escapeHtml(t.confirmation)}
      </p>
    </div>

    <div class="flex flex-col items-center justify-center gap-y-10">
      <div class="flex items-end ${footerGapClass}">
        <div class="flex w-[280px] flex-col items-center">
          <p
            class="text-[18px] text-gray-600"
            style="color:${escapeHtml(safeTheme.bodyTextColor)};"
          >
            ${escapeHtml(completionDate)}
          </p>
          <hr
            class="mx-auto mb-3 w-full"
            style="border-color:${escapeHtml(safeTheme.lineColor)};"
          />
          <p
            class="text-[18px] uppercase text-gray-800"
            style="color:${escapeHtml(safeTheme.labelTextColor)};"
          >
            ${escapeHtml(t.date)}
          </p>
        </div>

        ${expiryDateMarkup}

        <div class="flex w-[280px] flex-col items-center">
          ${signatureImageMarkup}
          <hr
            class="mx-auto mb-3 w-full"
            style="border-color:${escapeHtml(safeTheme.lineColor)};"
          />
          <p
            class="text-[18px] uppercase text-gray-800"
            style="color:${escapeHtml(safeTheme.labelTextColor)};"
          >
            ${escapeHtml(t.signature)}
          </p>
        </div>
      </div>

      <div class="flex items-end gap-x-12 text-center">
        <div class="flex flex-col items-center">
          <p
            class="whitespace-nowrap text-[16px] text-gray-600"
            style="color:${escapeHtml(safeTheme.bodyTextColor)};"
          >
            ${escapeHtml(score != null ? String(score) : result || t.completed)}
          </p>
          <hr
            class="mx-auto mb-3 w-full"
            style="border-color:${escapeHtml(safeTheme.lineColor)};"
          />
          <p
            class="text-[18px] uppercase text-gray-800"
            style="color:${escapeHtml(safeTheme.labelTextColor)};"
          >
            ${escapeHtml(score != null ? t.score : t.result)}
          </p>
        </div>

        <div class="flex flex-col items-center">
          <p
            class="whitespace-nowrap text-[16px] text-gray-600"
            style="color:${escapeHtml(safeTheme.bodyTextColor)};"
          >
            ${escapeHtml(certificateId || "\u2014")}
          </p>
          <hr
            class="mx-auto mb-3 w-full"
            style="border-color:${escapeHtml(safeTheme.lineColor)};"
          />
          <p
            class="text-[18px] uppercase text-gray-800"
            style="color:${escapeHtml(safeTheme.labelTextColor)};"
          >
            ${escapeHtml(t.certificateId)}
          </p>
        </div>
      </div>
    </div>
  </div>`;
  if (!isDownload) return certificateBodyMarkup;
  return `<div class="mx-auto h-[210mm] w-[297mm] overflow-hidden">${certificateBodyMarkup}</div>`;
}
function buildCertificateHtmlDocument(html, options) {
  return `<!DOCTYPE html>
<html lang="en">
  <head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <style>
      * {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
      }
      html, body {
        width: 297mm;
        height: 210mm;
        overflow: hidden;
        background-color: white;
      }
      body > * {
        width: 297mm;
        height: 210mm;
        transform-origin: top left;
      }
    </style>
    <title>Certificate</title>
    <style>${CERTIFICATE_STYLES}</style>
    ${CERTIFICATE_CONTENT_SECURITY_POLICY}
  </head>
  <body>
    ${html}
  </body>
</html>`;
}
var APP_LOGO_SVG = `<svg viewBox="0 0 591 246" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" xmlns:serif="http://www.serif.com/" style="height:100%;width:auto;display:block;fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;">
    <use id="Background" xlink:href="#_Image1" x="1" y="34" width="589px" height="178px"/>
    <defs>
        <image id="_Image1" width="589px" height="178px" xlink:href="data:image/png;base64,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"/>
    </defs>
</svg>`;
function escapeHtml(value) {
  return value.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#39;");
}
function escapeCssUrl(value) {
  return value.replace(/\\/g, "\\\\").replace(/"/g, '\\"').replace(/\(/g, "\\(").replace(/\)/g, "\\)").replace(/[\u0000-\u001f\u007f]/g, "");
}
function normalizeCertificateColor(value, fallback = "#1f2937") {
  return value && /^#(?:[0-9a-f]{3}|[0-9a-f]{4}|[0-9a-f]{6}|[0-9a-f]{8})$/i.test(value) ? value : fallback;
}
var CERTIFICATE_CONTENT_SECURITY_POLICY = `<meta http-equiv="Content-Security-Policy" content="default-src 'none'; img-src data: blob:; style-src 'unsafe-inline'; font-src data: blob:; frame-src 'none'; base-uri 'none'; form-action 'none'" />`;
var CERTIFICATE_STYLES = `
  *, ::before, ::after { box-sizing: border-box; margin: 0; padding: 0; border: 0 solid; }
  html { line-height: 1.5; font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; -webkit-text-size-adjust: 100%; }
  img, svg { display: block; vertical-align: middle; }
  img { max-width: 100%; height: auto; }
  hr { height: 0; color: inherit; border-top-width: 1px; }
  .flex { display: flex; }
  .flex-col { flex-direction: column; }
  .items-center { align-items: center; }
  .items-end { align-items: flex-end; }
  .justify-center { justify-content: center; }
  .h-full { height: 100%; }
  .w-full { width: 100%; }
  .h-11 { height: 2.75rem; }
  .h-16 { height: 4rem; }
  .w-\\[280px\\] { width: 280px; }
  .h-\\[210mm\\] { height: 210mm; }
  .w-\\[297mm\\] { width: 297mm; }
  .aspect-auto { aspect-ratio: auto; }
  .object-contain { object-fit: contain; }
  .mx-auto { margin-inline: auto; }
  .mb-2 { margin-bottom: .5rem; }
  .mb-3 { margin-bottom: .75rem; }
  .mb-4 { margin-bottom: 1rem; }
  .mt-2 { margin-top: .5rem; }
  .px-14 { padding-inline: 3.5rem; }
  .py-12 { padding-block: 3rem; }
  .gap-y-4 { row-gap: 1rem; }
  .gap-y-10 { row-gap: 2.5rem; }
  .gap-y-12 { row-gap: 3rem; }
  .gap-x-12 { column-gap: 3rem; }
  .gap-x-16 { column-gap: 4rem; }
  .gap-x-52 { column-gap: 13rem; }
  .text-\\[16px\\] { font-size: 16px; }
  .text-\\[17px\\] { font-size: 17px; }
  .text-\\[18px\\] { font-size: 18px; }
  .text-\\[24px\\] { font-size: 24px; }
  .text-\\[44px\\] { font-size: 44px; }
  .text-\\[62px\\] { font-size: 62px; }
  .font-black { font-weight: 900; }
  .font-semibold { font-weight: 600; }
  .uppercase { text-transform: uppercase; }
  .tracking-wider { letter-spacing: .05em; }
  .tracking-\\[0\\.2em\\] { letter-spacing: .2em; }
  .text-gray-600 { color: #4b5563; }
  .text-gray-800 { color: #1f2937; }
  .text-center { text-align: center; }
  .whitespace-nowrap { white-space: nowrap; }
  .overflow-hidden { overflow: hidden; }
`;

// src/utils/iframeUrls.ts
var IFRAME_ROUTES = {
  "www.youtube.com": /^\/embed\/[\w-]+\/?$/,
  "youtube.com": /^\/embed\/[\w-]+\/?$/,
  "www.youtube-nocookie.com": /^\/embed\/[\w-]+\/?$/,
  "youtube-nocookie.com": /^\/embed\/[\w-]+\/?$/,
  "player.vimeo.com": /^\/video\/\d+\/?$/,
  "iframe.mediadelivery.net": /^\/embed\/\d+\/[\w-]+\/?$/,
  "docs.google.com": /^\/presentation\/d\/(?:e\/)?[\w-]+\/(?:embed|pubembed|preview)\/?$/,
  "www.canva.com": /^\/design\/[\w-]+(?:\/[\w-]+)?\/view\/?$/,
  "canva.com": /^\/design\/[\w-]+(?:\/[\w-]+)?\/view\/?$/
};
var isAllowedIframeUrl = (source) => {
  if (typeof source !== "string" || !source.startsWith("https://")) return false;
  try {
    const url = new URL(source);
    if (url.protocol !== "https:") return false;
    if (url.username || url.password) return false;
    if (url.port) return false;
    const allowedRoute = IFRAME_ROUTES[url.hostname];
    return allowedRoute?.test(url.pathname) ?? false;
  } catch {
    return false;
  }
};

// src/utils/permissions.ts
var hasPermission = (permissions, permission) => {
  if (!permissions?.length) return false;
  return permissions.includes(permission);
};
var hasAnyPermission = (permissions, requiredPermissions) => {
  if (!requiredPermissions.length) return true;
  if (!permissions?.length) return false;
  return requiredPermissions.some((permission) => permissions.includes(permission));
};
var hasAllPermissions = (permissions, requiredPermissions) => {
  if (!requiredPermissions.length) return true;
  if (!permissions?.length) return false;
  return requiredPermissions.every((permission) => permissions.includes(permission));
};
var matchesRequirement = (permissions, requirement) => {
  if (!requirement) return true;
  const { anyOf = [], allOf = [] } = requirement;
  return hasAnyPermission(permissions, anyOf) && hasAllPermissions(permissions, allOf);
};

// src/utils/sanitizeRichText.ts
import sanitizeHtml from "sanitize-html";
var UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/;
var sanitizeRichText = (html) => {
  const blankTags = new Set(
    [...html.matchAll(BLANK_ANSWER_MARKER_REGEX)].map((match) => match[1].split(/\s/, 1)[0]).filter((answerId) => UUID_REGEX.test(answerId)).map((answerId) => `blank-answer-${answerId}`)
  );
  const sanitized = sanitizeHtml(html, {
    selfClosing: [...sanitizeHtml.defaults.selfClosing, ...blankTags],
    allowedTags: [
      ...blankTags,
      "p",
      "br",
      "div",
      "span",
      "h1",
      "h2",
      "h3",
      "h4",
      "h5",
      "h6",
      "strong",
      "b",
      "em",
      "i",
      "u",
      "s",
      "strike",
      "mark",
      "sub",
      "sup",
      "blockquote",
      "pre",
      "code",
      "hr",
      "ul",
      "ol",
      "li",
      "a",
      "img",
      "table",
      "thead",
      "tbody",
      "tfoot",
      "tr",
      "th",
      "td",
      "colgroup",
      "col",
      "iframe",
      "label",
      "input",
      "button"
    ],
    allowedAttributes: {
      "*": ["class", "id", "title", "data-*", "style"],
      a: ["href", "target", "rel", "download"],
      img: ["src", "alt", "width", "height"],
      ol: ["start"],
      th: ["colspan", "rowspan", "colwidth"],
      td: ["colspan", "rowspan", "colwidth"],
      col: ["span", "width"],
      button: [{ name: "type", values: ["button"] }],
      input: [{ name: "type", values: ["checkbox"] }, "checked", "disabled"],
      iframe: [
        "src",
        "title",
        "width",
        "height",
        "allowfullscreen",
        "frameborder",
        "loading",
        "sandbox"
      ]
    },
    allowedStyles: {
      "*": {
        color: [/^#[0-9a-f]{3,8}$/i, /^[a-z]+$/i, /^rgba?\([\d.,%\s]+\)$/i],
        "background-color": [/^#[0-9a-f]{3,8}$/i, /^[a-z]+$/i, /^rgba?\([\d.,%\s]+\)$/i],
        "text-align": [/^(left|right|center|justify)$/],
        width: [/^\d+(\.\d+)?(px|%)$/],
        "min-width": [/^\d+(\.\d+)?(px|%)$/]
      }
    },
    allowedSchemes: ["http", "https", "mailto", "tel"],
    allowedSchemesByTag: { iframe: ["https"] },
    exclusiveFilter: (frame) => frame.tag === "iframe" && !isAllowedIframeUrl(frame.attribs.src),
    // Tiptap promotes these data attributes to live links/media URLs.
    allowedSchemesAppliedToAttributes: [
      ...sanitizeHtml.defaults.allowedSchemesAppliedToAttributes,
      "data-src",
      "data-url"
    ],
    allowProtocolRelative: false,
    transformTags: {
      "*": (tagName, attribs) => ({
        tagName,
        attribs: blankTags.has(tagName) ? {} : attribs
      }),
      a: sanitizeHtml.simpleTransform("a", { rel: "noopener noreferrer" }),
      iframe: sanitizeHtml.simpleTransform("iframe", {
        sandbox: "allow-scripts allow-presentation"
      }),
      button: sanitizeHtml.simpleTransform("button", { type: "button" }),
      input: sanitizeHtml.simpleTransform("input", { type: "checkbox", disabled: "" })
    }
  });
  return sanitized.replace(BLANK_ANSWER_MARKER_REGEX, (marker) => {
    const tag = marker.slice(1, -3);
    return marker.endsWith(" />") && blankTags.has(tag) ? `<${tag}>` : marker;
  });
};

// src/utils/videoUrls.ts
var UUID_REGEX2 = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/i;
var tryParseUrl = (input) => {
  try {
    return new URL(input);
  } catch {
    try {
      return new URL(input, "http://localhost");
    } catch {
      return null;
    }
  }
};
var extractYoutubeId = (url) => {
  if (url.hostname === "youtu.be") {
    return url.pathname.replace("/", "").split("/")[0] || null;
  }
  if (url.pathname === "/watch") {
    return url.searchParams.get("v");
  }
  const pathParts = url.pathname.split("/").filter(Boolean);
  const embedIndex = pathParts.findIndex((part) => part === "embed" || part === "shorts");
  if (embedIndex !== -1 && pathParts[embedIndex + 1]) {
    return pathParts[embedIndex + 1];
  }
  return null;
};
var extractVimeoId = (url) => {
  const pathParts = url.pathname.split("/").filter(Boolean);
  const lastPart = pathParts[pathParts.length - 1];
  if (!lastPart) return null;
  return /^\d+$/.test(lastPart) ? lastPart : null;
};
var extractBunnyId = (sourceUrl, url) => {
  if (sourceUrl.startsWith("bunny-")) return sourceUrl.replace("bunny-", "");
  if (!url) return null;
  const pathParts = url.pathname.split("/").filter(Boolean);
  if (url.hostname === "iframe.mediadelivery.net") {
    const embedIndex = pathParts.findIndex((part) => part === "embed");
    if (embedIndex !== -1 && pathParts[embedIndex + 2]) {
      return pathParts[embedIndex + 2];
    }
  }
  const uuidSegment = pathParts.find((part) => UUID_REGEX2.test(part));
  if (uuidSegment) return uuidSegment.match(UUID_REGEX2)?.[0] ?? null;
  if (pathParts.length >= 2 && pathParts[pathParts.length - 1].endsWith(".jpg")) {
    return pathParts[pathParts.length - 2] ?? null;
  }
  return pathParts[pathParts.length - 1] ?? null;
};
var detectVideoProviderFromUrl = (sourceUrl) => {
  const url = tryParseUrl(sourceUrl);
  if (!url) return VIDEO_EMBED_PROVIDERS.UNKNOWN;
  if (extractResourceIdFromSourceUrl(sourceUrl)) {
    return VIDEO_EMBED_PROVIDERS.SELF;
  }
  const host = url.hostname.toLowerCase();
  if (host === "youtu.be" || host.endsWith("youtube.com")) return VIDEO_EMBED_PROVIDERS.YOUTUBE;
  if (host.endsWith("vimeo.com")) return VIDEO_EMBED_PROVIDERS.VIMEO;
  if (host.endsWith("bunny.net") || host.endsWith("bunnycdn.com") || host.includes("b-cdn") || host.includes("mediadelivery")) {
    return VIDEO_EMBED_PROVIDERS.BUNNY;
  }
  return VIDEO_EMBED_PROVIDERS.UNKNOWN;
};
var extractVideoIdFromSourceUrl = (sourceUrl, provider) => {
  const url = tryParseUrl(sourceUrl);
  switch (provider) {
    case VIDEO_EMBED_PROVIDERS.YOUTUBE:
      return url ? extractYoutubeId(url) : null;
    case VIDEO_EMBED_PROVIDERS.VIMEO:
      return url ? extractVimeoId(url) : null;
    case VIDEO_EMBED_PROVIDERS.BUNNY:
      return extractBunnyId(sourceUrl, url);
    default:
      return null;
  }
};
var extractResourceIdFromSourceUrl = (sourceUrl) => {
  if (UUID_REGEX2.test(sourceUrl)) return sourceUrl.match(UUID_REGEX2)?.[0] ?? null;
  const url = tryParseUrl(sourceUrl);
  if (!url) return null;
  const match = url.pathname.match(/\/(?:lesson|articles|news)-resource\/([0-9a-f-]{36})/i);
  if (match?.[1]) return match[1];
  const pathParts = url.pathname.split("/").filter(Boolean);
  const lastPart = pathParts[pathParts.length - 1];
  if (lastPart && UUID_REGEX2.test(lastPart)) return lastPart;
  return null;
};
export {
  ACCESS_GUARD,
  ACTIVITY_LOG_ACTION_TYPES,
  ACTIVITY_LOG_RESOURCE_ACTION_TYPES,
  ACTIVITY_LOG_RESOURCE_TYPES,
  AI_MENTOR_TTS_PRESET,
  AI_MENTOR_TYPE,
  AI_MENTOR_VOICE_MODE,
  ALLOWED_AGE_LIMITS,
  ALLOWED_ARTICLES_SETTINGS,
  ALLOWED_AUDIO_FILE_EXTENSIONS,
  ALLOWED_AUDIO_FILE_TYPES,
  ALLOWED_EXCEL_FILE_TYPES,
  ALLOWED_EXTENSIONS,
  ALLOWED_IMAGE_FILE_EXTENSIONS,
  ALLOWED_LESSON_IMAGE_FILE_TYPES,
  ALLOWED_MARKDOWN_FILE_TYPES,
  ALLOWED_NEWS_SETTINGS,
  ALLOWED_ODP_FILE_TYPES,
  ALLOWED_PDF_FILE_EXTENSIONS,
  ALLOWED_PDF_FILE_TYPES,
  ALLOWED_PRESENTATION_FILE_EXTENSIONS,
  ALLOWED_PRESENTATION_FILE_TYPES,
  ALLOWED_QA_SETTINGS,
  ALLOWED_SCORM_PACKAGE_FILE_EXTENSIONS,
  ALLOWED_SCORM_PACKAGE_MIME_TYPES,
  ALLOWED_SPREADSHEET_FILE_EXTENSIONS,
  ALLOWED_VIDEO_FILE_EXTENSIONS,
  ALLOWED_VIDEO_FILE_TYPES,
  ALLOWED_WORD_FILE_EXTENSIONS,
  ALLOWED_WORD_FILE_TYPES,
  ANNOUNCEMENT_AUDIENCES,
  ANNOUNCEMENT_EMAIL_TEMPLATES,
  ANNOUNCEMENT_FEEDS,
  ANNOUNCEMENT_SOURCE_TYPES,
  ANNOUNCEMENT_STATUSES,
  ANSWER_REVIEW_STATUS,
  ARTICLE_STATUS,
  AUTH_SESSION_STATUS,
  AUTH_TOKEN_PURPOSE,
  BLANK_ANSWER_MARKER_REGEX,
  BYTES_PER_MEGABYTE,
  CALENDAR_EVENT_SOURCE_ROLES,
  CALENDAR_EVENT_SOURCE_TYPES,
  CALENDAR_EVENT_STATUSES,
  CERTIFICATE_ARCHIVE_REASONS,
  CERTIFICATE_CONTENT_SECURITY_POLICY,
  CERTIFICATE_KIND,
  CERTIFICATE_MODES,
  CERTIFICATE_RESET_SCOPES,
  CERTIFICATE_RESULTS,
  CERTIFICATE_STATUSES,
  CERTIFICATE_STYLES,
  CERTIFICATE_TARGET_TYPES,
  CERTIFICATE_VALIDITY_TYPES,
  CERTIFICATE_VALIDITY_UNITS,
  COURSE_CHAT_ALLOWED_REACTIONS,
  COURSE_CHAT_SOCKET_EVENTS,
  COURSE_ENROLLMENT,
  COURSE_FEATURE,
  COURSE_FEATURE_ERROR_TRANSLATION_KEY,
  COURSE_GENERATION_MESSAGE_KEY,
  COURSE_GENERATION_STREAM_EVENT_TYPE,
  COURSE_GENERATION_SYNC_SOCKET_EVENT,
  COURSE_GENERATION_SYNC_STATUS,
  COURSE_ORIGIN_TYPES,
  COURSE_PROGRESS_STATUSES,
  COURSE_STATUSES,
  COURSE_TYPE,
  COURSE_TYPE_DISABLED_FEATURES,
  DEFAULT_LIVE_TRAINING_SETTINGS,
  DEFAULT_TUS_CHUNK_SIZE,
  DEFAULT_TUS_TTL_MS,
  DIFFICULTY_LEVEL,
  DIFFICULTY_LEVEL_ORDER,
  ENTITY_TYPES,
  EXTERNAL_INTEGRATIONS_ENABLED,
  FEATURES,
  FEATURE_SETTINGS_KEYS,
  FORM_FIELD_TYPES,
  FORM_TYPES,
  HEX_COLOR_REGEX,
  LEARNING_PATH_CERTIFICATE_STATUSES,
  LEARNING_PATH_ENROLLMENT_TYPES,
  LEARNING_PATH_ENTITY_TYPES,
  LEARNING_PATH_PROGRESS_STATUSES,
  LEARNING_PATH_STATUSES,
  LESSON_TYPES,
  LIVE_TRAINING_DELIVERY_TYPES,
  LIVE_TRAINING_DESCRIPTION_MAX_LENGTH,
  LIVE_TRAINING_LINK_ENTITY_TYPES,
  LIVE_TRAINING_MAX_PARTICIPANTS_LIMIT,
  LIVE_TRAINING_MEMBER_ROLES,
  LIVE_TRAINING_PARTICIPANT_ROLES,
  LIVE_TRAINING_RESOURCE_RELATIONSHIP_TYPES,
  LIVE_TRAINING_SESSION_STATUSES,
  LIVE_TRAINING_SOCKET_CLIENT_EVENTS,
  LIVE_TRAINING_SOCKET_ROOMS,
  LIVE_TRAINING_SOCKET_ROOM_BUILDERS,
  LIVE_TRAINING_SOCKET_SERVER_EVENTS,
  LIVE_TRAINING_STATUSES,
  LIVE_TRAINING_TITLE_MAX_LENGTH,
  LIVE_TRAINING_VISIBILITY_SCOPES,
  LUMA_FILE_INGESTION_ALLOWED_EXTENSIONS,
  LUMA_FILE_INGESTION_ALLOWED_MIME_TYPES,
  MASTER_COURSE_ENTITY_TYPES,
  MASTER_COURSE_EXPORT_SYNC_STATUSES,
  MAX_AVATAR_FILE_SIZE_BYTES,
  MAX_AVATAR_FILE_SIZE_MB,
  MAX_COURSE_TITLE_LENGTH,
  MAX_COURSE_TRAILER_VIDEO_SIZE_BYTES,
  MAX_COURSE_TRAILER_VIDEO_SIZE_MB,
  MAX_FILE_SIZE_BYTES,
  MAX_FILE_SIZE_MB,
  MAX_IMAGE_FILE_SIZE_BYTES,
  MAX_IMAGE_FILE_SIZE_MB,
  MAX_INGESTION_FILE_COUNT,
  MAX_INGESTION_FILE_SIZE_BYTES,
  MAX_INGESTION_FILE_SIZE_MB,
  MAX_LOGIN_PAGE_DOCUMENTS,
  MAX_PRESENTATION_FILE_SIZE_BYTES,
  MAX_PRESENTATION_FILE_SIZE_MB,
  MAX_SCORM_PACKAGE_SIZE_BYTES,
  MAX_SCORM_PACKAGE_SIZE_MB,
  MAX_SCORM_THUMBNAIL_FILE_SIZE_BYTES,
  MAX_SCORM_THUMBNAIL_FILE_SIZE_MB,
  MAX_SETTINGS_IMAGE_FILE_SIZE_BYTES,
  MAX_SETTINGS_IMAGE_FILE_SIZE_MB,
  MAX_USER_NAME_LENGTH,
  MAX_VIDEO_FILE_SIZE_BYTES,
  MAX_VIDEO_FILE_SIZE_MB,
  MEGABYTE_UNIT,
  NEWS_STATUS,
  OnboardingPages,
  PERMISSIONS,
  QUESTION_GRADING_MODE,
  QUESTION_GRADING_MODE_MAX_SCORE,
  RESOURCE_LIBRARY_ASSET_TYPE,
  SCORM_12_API_METHODS,
  SCORM_12_RUNTIME_SETTINGS,
  SCORM_BRIDGE_CONFIG,
  SCORM_BRIDGE_MESSAGE_TYPES,
  SCORM_BRIDGE_METHODS,
  SCORM_COMPLETION_STATUS,
  SCORM_CONTENT_ACCESS,
  SCORM_CONTENT_PATHS,
  SCORM_CONTENT_TOKEN,
  SCORM_IMPORT_ACTION,
  SCORM_IMPORT_SOCKET,
  SCORM_PACKAGE_ENTITY_TYPE,
  SCORM_PACKAGE_STATUS,
  SCORM_PLAYER_ATTRIBUTES,
  SCORM_STANDARD,
  SCORM_SUCCESS_STATUS,
  SESSION_REVOCATION_SOCKET,
  SHARE_IMAGE_HEIGHT,
  SHARE_IMAGE_WIDTH,
  SUPPORTED_LANGUAGES,
  SUPPORT_SESSION_STATUSES,
  SYSTEM_ROLE_PERMISSIONS,
  SYSTEM_ROLE_SLUGS,
  SYSTEM_RULE_SET_SLUGS,
  TENANT_STATUSES,
  USER_NOTIFICATION_TYPE,
  VIDEO_AUTOPLAY,
  VIDEO_EMBED_PROVIDERS,
  VIDEO_PROVIDERS,
  VIDEO_UPLOAD_STATUS,
  VOICE_ACTION,
  VOICE_MODE_STATE,
  VOICE_SOCKET_EVENT,
  buildCertificateHtmlDocument,
  buildCertificateMarkup,
  defaultCertificateRenderTheme,
  detectVideoProviderFromUrl,
  extractResourceIdFromSourceUrl,
  extractVideoIdFromSourceUrl,
  extractVimeoId,
  extractYoutubeId,
  getCourseChatRoom,
  hasAllPermissions,
  hasAnyPermission,
  hasPermission,
  isAllowedIframeUrl,
  isCourseFeatureEnabledForCourseType,
  isSupportedLanguage,
  matchesRequirement,
  normalizeCertificateColor,
  sanitizeRichText,
  tryParseUrl
};
